import React, { useEffect, useState } from "react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { reApi, errMsg } from "@/lib/residentApi";
import FinancialTab from "@/components/nds/windows/resident/FinancialTab";

/** The resident's full Financial page (paychecks, ledger fixes, move money) in a side panel, without leaving the Finance Report. */
export default function ResidentMoneyPanel({ rid, name, open, onClose }) {
  const [res, setRes] = useState(null);
  const [err, setErr] = useState(null);
  useEffect(() => {
    if (!open || !rid) return;
    setRes(null); setErr(null);
    reApi.get(`/residents/${rid}`).then(setRes).catch((e) => setErr(errMsg(e)));
  }, [open, rid]);
  return (
    <Sheet open={open} onOpenChange={(v) => !v && onClose()}>
      <SheetContent side="right" data-testid="resident-money-panel" className="bg-[#0b0f1f] text-slate-100 border-white/10 w-full sm:max-w-3xl h-full overflow-y-auto">
        <SheetHeader><SheetTitle className="font-serif text-nex-silver">{name || "Resident"} · Financial page</SheetTitle></SheetHeader>
        <div className="mt-4">
          {err ? <p data-testid="resident-money-panel-error" className="text-sm text-red-300">{err}</p>
            : !res ? <p className="text-sm text-nex-muted">Loading…</p> : <FinancialTab resident={res} />}
        </div>
      </SheetContent>
    </Sheet>
  );
}
